export default __webpack_public_path__ + "images/poppy-sad.svg";